import '@fontsource/league-gothic/400.css';
import '@fontsource/bodoni-moda/400-italic.css';
import '@fontsource/bodoni-moda/700.css';
import '@fontsource/bodoni-moda/800.css';
import '@fontsource/bodoni-moda/900.css';
import '@fontsource/courier-prime/400.css';
import '@fontsource/courier-prime/700.css';
import '@fontsource-variable/atkinson-hyperlegible-next/wght.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/screens.css';

import { render } from 'preact';
import { inkWear } from './art/text.ts';
import { loadPublicConfig, restoreSession } from './net/client.ts';
import { BoardDirector } from './stage/board.ts';
import { App } from './ui/App.tsx';

/** DOM stamps wear the same speckled rubber as the canvas ones, through a CSS mask. */
function installInkWear(): void {
  const canvas = document.createElement('canvas');
  canvas.width = 256;
  canvas.height = 256;
  const ctx = canvas.getContext('2d')!;
  ctx.fillRect(0, 0, 256, 256);
  inkWear(ctx, 256, 256, 7, 0.9);
  document.documentElement.style.setProperty('--ink-wear', `url(${canvas.toDataURL('image/png')})`);
}

installInkWear();
render(<App />, document.getElementById('app')!);
void loadPublicConfig();
restoreSession();

const canvas = document.getElementById('stage') as HTMLCanvasElement;
try {
  void new BoardDirector(canvas).start();
} catch (error) {
  // No WebGL: the game is fully playable from the DOM, the board simply stays felt green.
  console.warn('3D board unavailable', error);
  canvas.remove();
}
